if (!String.prototype.compare) {
    String.prototype.compare = function (str) {
        return this.localeCompare(str)
    }
}

if (!String.prototype.trimChars) {
    String.prototype.trimChars = function (char) {
        var shouldTrim = (c) => c == char
        if (Array.isArray(char)) {
            shouldTrim = (c) => char.includes(c)
        }
        var start = 0
        var end = this.length

        while (start < end && shouldTrim(this[start])) {
            ++start
        }

        while (end > start && shouldTrim(this[end - 1])) {
            --end
        }

        if (start <= 0 && end >= this.length) {
            return this
        }
        return this.substring(start, end)
    }
}

if (!String.prototype.splitOnIndex) {
    String.prototype.splitOnIndex = function (index) {
        return [this.slice(0, index), this.slice(index)]
    }
}

if (!String.prototype.slitOn) {
    String.prototype.splitOn = function (condition) {
        var index = 0
        if (typeof condition === 'number') {
            index = condition
        } else if (typeof condition !== 'function') {
            throw 'Must supply a condition to splitOn'
        } else {
            for (const char of this) {
                if (condition(char, index)) {
                    break
                }
                index++
            }
        }
        return this.splitOnIndex(index)
    }
}

if (!String.prototype.splitOnLastOccurrence) {
    String.prototype.splitOnLastOccurrence = function (charToSplit) {
        const lastIndex = this.lastIndexOf(charToSplit)

        if (lastIndex === -1) {
            // The character is not found in the string, return the original string.
            return [this]
        }

        const part1 = this.substring(0, lastIndex)
        const part2 = this.substring(lastIndex + 1)

        return [part1, part2]
    }
}

if (!String.prototype.splitOnIndexes) {
    String.prototype.splitOnIndexes = function (indexes) {
        if (!Array.isArray(indexes)) {
            throw `Expected array for splitOnIndexes, got: ${typeof indexes}`
        }
        indexes = indexes.defaultSort()
        return indexes.reduce((arr, indexToSplitOn, i) => {
            var item = arr.pop() || this
            var shrunkIndex = indexToSplitOn - (indexes[i - 1] || 0)
            var split = item.splitOnIndex(shrunkIndex)
            return arr.concat(split)
        }, [])
    }
}

if (!String.prototype.contains) {
    String.prototype.contains = function (search, ignoreCase) {
        if (!search || typeof search !== 'string') {
            return false
        }
        if (ignoreCase) {
            return this.toLowerCase().includes(search.toLowerCase(), 0)
        }
        return this.includes(search, 0)
    }
}

if (!String.prototype.hash) {
    String.prototype.hash = function () {
        let hash = 0
        for (let i = 0; i < this.length; i++) {
            const char = this.charCodeAt(i)
            hash = (hash << 5) - hash + char
            hash &= hash // Convert to 32bit integer
        }
        return new Uint32Array([hash])[0].toString(36)
    }
}

if (!String.prototype.compareIgnore) {
    String.prototype.compareIgnore = function (str) {
        return this.localeCompare(str, 'en', { sensitivity: 'base' })
    }
}

if (!String.prototype.formatCurrency) {
    String.prototype.formatCurrency = function () {
        return Number(this).formatCurrency()
    }
}

if (!String.prototype.capitalize) {
    String.prototype.capitalize = function () {
        var words = this.split(/\s+/)
        var capitalized_array = words
            .where((w) => !!w)
            .map((word) => {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            })
        return capitalized_array.join(' ')
    }
}

if (!String.prototype.splitPascalCase) {
    String.prototype.splitPascalCase = function () {
        var words = this.match(/([A-Z]?[a-z]+|[A-Z]+(?=[A-Z]|$))/g)
        var split_words = words.filter((w) => !!w)
        return split_words.join(' ')
    }
}

if (!String.prototype.toTitleCase) {
    String.prototype.toTitleCase = function () {
        return this.toPascalCase().splitPascalCase().capitalize()
    }
}

if (!String.prototype.toCamelCase) {
    String.prototype.toCamelCase = function () {
        var titleCase = this.toTitleCase().replace(/\s/g, '')

        if (titleCase.length === 0) {
            return ''
        }
        return titleCase.charAt(0).toLowerCase() + titleCase.slice(1)
    }
}

if (!String.prototype.toKebabCase) {
    String.prototype.toKebabCase = function () {
        return this.split('')
            .map((letter, idx) => {
                return letter.toUpperCase() === letter
                    ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`
                    : letter
            })
            .join('')
    }
}

if (!String.prototype.toSnakeCase) {
    String.prototype.toSnakeCase = function (uppercase) {
        var val = this.trim()
        val = val.replace(/([A-Z]+[^A-Z])/g, '_$1')
        val = val.replace(/([A-Z][a-z])/g, '_$1')
        val = val.replace(/[\s_]+/g, '_')
        if (uppercase) {
            return val.toUpperCase()
        }
        return val.toLowerCase()
    }
}

if (!String.prototype.toPascalCase) {
    String.prototype.toPascalCase = function () {
        return this.split('-')
            .map((word) => {
                if (!word) {
                    return ''
                }
                return word.charAt(0).toUpperCase() + word.slice(1)
            })
            .join('')
    }
}

if (!String.prototype.parseHeaderValues) {
    String.prototype.parseHeaderValues = function () {
        return this.split('; ').toObject((s) => s.split('=')[0])
    }
}

if (!String.prototype.asLocalPhone) {
    String.prototype.asLocalPhone = function () {
        var value = this
        if (!value || !value.startsWith('+61')) {
            return value
        }

        // replace all whitespace and beginning +61
        value = value.replace(/^\+61|\s+/g, '')
        var parts = []
        switch (value.length) {
            // Business + reverse numbers: 1300 661 557
            case 10:
                parts = value.splitOnIndexes([4, 7])
                break

            // Standard national numbers: (0)3 9727 7766 or (0)430 988 788
            case 9:
                value = '0' + value
                if (value.startsWith('04')) {
                    parts = value.splitOnIndexes([4, 7])
                    break
                }
                parts = `${value}`.splitOnIndexes([2, 6])
                parts[0] = `(${parts[0]})`
                break

            // Short national numbers: 13 13 99
            case 6:
                parts = value.splitOnIndexes([2, 4])
                break

            default:
                parts = [value]
                break
        }

        return parts.join(' ')
    }
}

if (!String.prototype.asInternationalPhone) {
    String.prototype.asInternationalPhone = function () {
        var value = this
        if (value.startsWith('+') || !value.startsWith('0')) {
            return value
        }
        return value.replace('0', '+61')
    }
}

if (!String.prototype.asAbn) {
    String.prototype.asAbn = function () {
        var value = this
        if (!value) {
            return 'No Abn'
        }
        var trimmedValue = value.replace(/\s+/g, '')
        // var matcher = value.match(/^(\d{2})?(\d{3})?(\d{3})?(\d{3})$/g)
        var firstSeq = trimmedValue.substring(0, 2)
        var secondSeq = trimmedValue.substring(2, 5)
        var thirdSeq = trimmedValue.substring(5, 8)
        var finalSeq = trimmedValue.substring(8, 11)
        return `${firstSeq}-${secondSeq}-${thirdSeq}-${finalSeq}`
    }
}
